export default "__VITE_ASSET__ZC8zCQ6j__"